common.View.create('crud::form.Readonly', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.setFieldsReadonly();
    },

    /**
     * Initializes the GUI.
     */
    setFieldsReadonly() {
        $('.form-readonly fieldset')
            .find('input, textarea, select')
            .prop('readonly', true);
    },

});
